import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isBackendFalsy } from '@Sage/ssm-utils/backendScalars';

import { EntityDetailActions } from 'actions';
import { COMPANIES } from 'constants/Entities';

const companyTabKey = (companyId) => `${COMPANIES.entity}-${companyId}`;

function resolveCompanyStateId(entity) {
    if (!entity) return null;
    return entity.idCompanyState?.value ?? entity.idCompanyState ?? entity.idcompanystate ?? null;
}

const useDisableCreateSalesOrders = (data) => {
    const dispatch = useDispatch();

    const activeTabData = useSelector(
        (state) => state.entityDetail[state.entityDetail.active]?.data,
    );
    const companyStatesList = useSelector(
        (state) => state.serverList?.tblEstadosEmpresa?.data ?? [],
    );

    const entity = data ?? activeTabData;
    const companyId = entity?.idCompany?.value ?? entity?.idCompany;

    const companyData = useSelector((state) =>
        !isBackendFalsy(companyId)
            ? (state.entityDetail[companyTabKey(companyId)]?.data ?? null)
            : null,
    );

    useEffect(() => {
        if (!isBackendFalsy(companyId) && companyData == null) {
            dispatch(EntityDetailActions.prefetchCompanyForDetail(companyId));
        }
    }, [companyId, companyData, dispatch]);

    return useMemo(() => {
        const stateId = resolveCompanyStateId(entity) ?? resolveCompanyStateId(companyData);
        if (stateId == null) return false;

        const companyState = companyStatesList.find((s) => String(s.value) === String(stateId));
        return companyState?.disableCreateSalesOrders === true;
    }, [companyData, companyStatesList, entity]);
};

export default useDisableCreateSalesOrders;
